const $ = require('jquery');
require('slick-carousel');

const settings = {
	carousel: '[data-slick]',
	controlWrapper: '[data-slick-custom-control-wrapper]',
	responsive: 'data-slick-responsive',
	hasPrev: '[data-slick-custom-control-prev]',
	hasNext: '[data-slick-custom-control-next]'
}

export function init () {
	let $carousels = $(settings.carousel);

	if ($carousels.length) {
		$carousels.each(function () {
			let $this = $(this);
			let options = {
				autoplaySpeed: 6000,
				focusOnSelect: true
			};

			if ($this.attr(settings.responsive)) {
				options = Object.assign(options, {
					responsive: [
						{
							breakpoint: 1200,
							settings: {
								slidesToShow: 12
							}
						},
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 6
							}
						},
						{
							breakpoint: 576,
							settings: {
								slidesToShow: 3
							}
						}
					]
				});
			}

			$this.slick(options);

			if ($(settings.controlWrapper).length) {
				let $customControlWrapper = $(settings.controlWrapper);
				let $prev = $customControlWrapper.find(settings.hasPrev);
				let $next = $customControlWrapper.find(settings.hasNext);

				if ($prev.length) {
					$prev.on('click', function () {
						$this.slick('slickPrev');
					});
				}

				if ($next.length) {
					$next.on('click', function () {
						$this.slick('slickNext');
					});
				}
			}
		})
	}
}

export function resize () {
	$(settings.carousel).resize();
}

init();
